<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Token } from '@Shelly/shelly-design-system';
	import { getApplianceTypes, getReturnedEnergyTypes } from 'src/helpers/device_settings_helpers';
	import type { ApplianceType } from 'src/helpers/device_settings_helpers';
	import { capFirstChar, calculateTokenWidthByTitle } from 'src/helpers/utilities';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	const types: ApplianceType[] = getApplianceTypes()
		.filter((at) => at.value !== 0)
		.map((at) => {
			at.title = capFirstChar(at.title);
			return at;
		});
	// will cap first until 'text-capitalize' class can be applied to <Select> options from outside

	const sources: ApplianceType[] = getReturnedEnergyTypes()
		.filter((at) => at.value !== 0)
		.map((at) => {
			at.title = capFirstChar(at.title);
			return at;
		});

	let selected;

	const selectType = (type: ApplianceType) => {
		type.selected = !type.selected;
		selected = type;
		dispatch('toggler', selected);
	};
</script>

<Text styleType="body" class="mb-m"
	>{$format('title_appliance_types', { default: 'Appliance types' })}</Text
>
<div class="d-flex flex-wrap gap-s mb-m">
	{#each types as type}
		<Token
			id="token-5d9rfhv"
			size="m"
			title={type.title}
			class="text-nowrap"
			width={calculateTokenWidthByTitle(type.title)}
			icon={`fas fa-${type.icon}`}
			selected={selected?.usage === type?.usage}
			on:click={() => {
				selectType(type);
			}}
		/>
	{/each}
</div>
<Text styleType="body" class="mb-m">{$format('title_consumption_source', { default: 'Source' })}</Text>
<div class="d-flex flex-wrap gap-s mb-m">
	{#each sources as source}
		<Token
			id="token-zhhdbx2"
			size="m"
			title={source.title}
			class="mb-xs mr-xs text-nowrap"
			width={calculateTokenWidthByTitle(source.title)}
			icon={source.icon}
			selected={selected?.usage === source?.usage}
			on:click={() => {
				selectType(source);
			}}
		/>
	{/each}
</div>
